import {API} from './API.js';
import {RowExpander} from './RowExpander.js';
import {SAFire} from './safire.js';
import {Templates} from './Templates.js';

const delay = ms => new Promise(res => setTimeout(res, ms));

class SACode {
	constructor(js, parent, selector) {
		this.js = js;
		this.parent = parent;
		this.selector = selector;
		// this.children is _null_ before loading happens
		this.children = null;
		// this flag is used while loading is happening
		this.loading = false;
		
		// expanded tells whether this node is in an expanded state. 
		this.expanded = false;
		
		[this.el, this.$] = Templates('SACodeSelector.Code');
		this.$.code.innerText = js.code;
		this.$.name.innerText = js.name;
		this.$.scc.innerText = js.scc;
		this.el.classList.add(`level-${js.level}`);
		this.el.addEventListener('click', (evt)=>{
			if (null===this.children) {
				if (this.loading) return;
				this.$.loader.classList.add('loading');
				if (this.js.level<3) {
					this.loading = true;
					// TODO: Need version and namespace support in SACode
					SAFire.API().SACode(null, null, this.js.code).then(
						js=>{
							this.children = [];
							// console.log(`SAFire(${this.js.code}) returned `, js);
							js[0].children.forEach(cd=>{
								this.appendChild(new SACode(cd, this, this.selector));
							});
							this.expanded = true;
							if (0==this.children.length) {
								this.$.loader.classList.add('no-children');
							}
							this.$.loader.classList.add('expanded');
						}).finally( ()=>{ 
							this.loading = false;
							this.$.loader.classList.remove('loading');
						});
				} else {
					this.selector.dispatchEvent(new CustomEvent('safire-sacode-click', {
						bubbles:true,
						composed:true,
						detail: {
							sacode: this.js,
						}
					}));
				}
			} else {
				this.expanded = !this.expanded;
				this.$.loader.classList[ this.expanded ? "add" : "remove" ]("expanded");
				this.children.forEach( c=>c.show(this.expanded));
				if (this.js.level==3 && this.expanded) {
					this.selector.dispatchEvent(new CustomEvent('safire-sacode-click', {
						bubbles:true,
						composed:true,
						detail: {
							sacode: this.js,
						}
					}));
				}
			}
		});
		if (js.level>2) {
			this.$.loader.classList.add('no-children');
		}
	}
	show(expand) {
		this.el.classList[ (!expand) ? "add" : "remove" ]("hidden");
		if (null!==this.children && this.expanded) {
			this.children.forEach( c=>c.show(expand) );
		}
	}
	appendChild(cd) {
		if (this.children.length==0) {
			this.el.after(cd.el);
		} else {
			this.children[this.children.length-1].el.after(cd.el);
		}
		this.children.push(cd);
	}
}

export class SACodeSelector extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates('SACodeSelector');
		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
		//this.addEventListener(`safire-sacode-details`, evt=>this.showSACodeDetails(evt));
	}
	connectedCallback() {
		// @TODO : require version and namespace support for SACode call
		SAFire.API().SACode(null, null, '').then(
			js=>{
				js.forEach(cd => {
					const c = new SACode(cd, null, this);
					this.$.codes.appendChild(c.el);
				});
			});
	}

}
customElements.define('safire-sacode-selector', SACodeSelector);
